import React from "react";
import LandingPageLayout from "../layouts/LandingPageLayout";
import MyDish from "../LandingPageTemplates/Components/MyDish";

export const LandingPageRoutes = () => {
    return (
        <React.Fragment>
            <LandingPageLayout exact path="/PartnerHomeLogin/TMPL9" component={MyDish} />
        </React.Fragment>
    );
};
